import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface UpdateIFRSQuestionDTO {
  description: string;
  marks?: number;
  requirements?: string;
}

export interface UpdateIFRSQuestionResponse {
  id: string;
  status: string;
  description: string;
  marks?: number;
  requirements?: string;
  ifrsId: string;
}

type UpdateIFRSQuestionAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: UpdateIFRSQuestionResponse;
};

export const UpdateIFRSQuestion = async (
  ifrsId: string,
  questionId: string,
  data: UpdateIFRSQuestionDTO
): Promise<UpdateIFRSQuestionAPIResponse> => {
  try {
    const response = await axios.patch(`/ifrs/${ifrsId}/questions/${questionId}`, data);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

